import React from 'react'
import { curry } from 'ramda'
import { Field } from 'redux-form/immutable'

import withExtras from './withExtras'
import { createValidatorsFromProps } from './helpers'

const enhance = curry((_, Component) => {
  const ComponentWithExtras = withExtras(Component)
  return props => {
    const validatorFuncs = createValidatorsFromProps(props)
    return (
      <Field
        {...props}
        component={ComponentWithExtras}
        validate={validatorFuncs}
        validators={validatorFuncs}
      />
    )
  }
})

export default enhance
